/* PERSON - Diese Datei wird NICHT generiert */
(function() {
  'use strict';
  angular.module('cfn').directive('cfnBookingPerson', cfnBookingPerson);

  cfnBookingPerson.$inject = [
    'bookingRules',
    'bookingService',
    '$timeout',
    'companyFinanceService',
    'search.service',
    'userSettingsService'
  ];
  function cfnBookingPerson(
    bookingRules,
    bookingService,
    $timeout,
    companyFinanceService,
    searchService,
    userSettingsService
  ) {
    return {
      restrict: 'E',
      templateUrl: require('./personTable.html'),
      controller: [
        '$scope',
        function($scope) {
          $scope.isEngland = userSettingsService.getIsoCountryEnum() === 'GBR';
          var objectType = $scope.ele.name,
            type = 'resource',
            list = objectType + 'List';

          // Load data from common booking state object into local format
          bookingRules.elements.person.onLoad = function(result) {
            // result.resources[resourceType=="Person"] -> $scope.details.personList
            $scope.details.personList = result.resources.filter(function(
              resource
            ) {
              return resource.resourceType === 'Person';
            });
            if (searchIndex) {
              searchIndex.clearExcludedItems();
            }
            excludeAllAddedFields();
          };

          // Transform details-data (fieldList, seedList, ...) to BE-Data (assets, products,...)
          bookingRules.elements.person.onSave = function(result) {
            if (!angular.isArray(result.resources)) result.resources = [];
            if ($scope.details.personList)
              $scope.details.personList.forEach(function(person) {
                person.resourceType = 'Person';
                result.resources.push(person);
              });
          };

          bookingRules.elements.person.onInsert = function(recourceDTO) {
            var newItem = recourceDTO;

            // Area is sum of all fields per default
            newItem.workedArea = $scope.details.fieldList_farmedArea_sum;
            if (newItem.unit == 'AREAL_HA') {
              newItem.amount = newItem.workedArea;
            } else {
              newItem.amount = 0;
            }

            // set id in item for easy unique-check.
            newItem.feid = recourceDTO.resource.id;

            bookingService.addToList($scope, newItem, 'personList');
            excludeAllAddedFields();
          };

          $scope.currencySign = companyFinanceService.getCurrencySign();

          function excludeAllAddedFields() {
            _.each($scope.details.personList, function(item) {
              searchIndex.excludeFromIndex(item.resource.id);
            });
          }

          $scope.remove = function(item) {
            searchIndex.undoExcludeFromIndex(item.resource.id);
            $scope.controller.removeFromList(objectType, type, list, item);
          };

          $scope.checkUnit = function(item) {
            $timeout(function() {
              if (item.unit == 'AREAL_HA') {
                item.amount = item.workedArea;
              }
            });
          };
          //search
          var searchIndex = searchService(objectType, {
            initOnFirstSearch: true
          }).buildIndex({
            fullText: function(item) {
              return [
                item.combinedName,
                item.number,
                enums.PersonCategoryEnum[item.category]
              ];
            },
            handleResults: function(data) {
              data.map(function(elem) {
                elem._objectType = objectType; //this is required later on but legacy code...
              });
              return data;
            }
          });
          $scope.search = searchIndex.fullTextSearch;
          $scope.searchSelected = function(selectedItem) {
            $scope.addToList(objectType, type, list, null)(selectedItem);
          };
        }
      ]
    };
  }
})();
